import Vue from 'vue'
import Vuex from 'vuex'
import {firebaseMutations} from 'vuexfire'
import firebase from 'firebase/app'
import user from '../store/user'
import link from '../store/link'
import pdf from '../store/pdf'


Vue.use(Vuex);

export default new Vuex.Store({
    mutations: firebaseMutations,
    strict: true,
    modules: {
        user: user,
        link: link,
        pdf: pdf
    },

    actions: {

        init: function (context, user) {
            return new Promise(resolve => {
                context.dispatch('user/setList', firebase.database().ref('/users/'));
                context.dispatch('link/setList', firebase.database().ref('/link/'));
                context.dispatch('pdf/setList', firebase.database().ref('/pdfs/'));
                resolve();

            })


        },

    }
})
